import { useImperativeHandle } from "react";
import { createProxy, createProxyBase } from "./proxy";

const uriGenerate = name => createProxyBase(name);

const uri = {
    activities: createProxyBase('activities'),
    bill: createProxyBase('bill'),
    receivables: createProxyBase('receivables'),
    quotation: createProxyBase('quotation'),
    appointments: createProxyBase('appointments'),
    clients: createProxyBase('clients'),
    professions: createProxyBase('professions'),
    categories: createProxyBase('categories'),
    billPaymentTypes: createProxyBase('billPaymentTypes'),
    billPaymentMethods: createProxyBase('billPaymentMethods'),
    banks: createProxyBase('banks'),
    sclerals: createProxyBase('sclerals'),
    status: createProxyBase('status'),
    doctors: createProxyBase('doctors'),    
    vendors: createProxyBase('vendors'),
    file: createProxy('', 'tasaCambio/post/file'),
    sms: createProxyBase('sms'),
    notificationTemplates: createProxyBase('notificationTemplates'),
    usersManagement:createProxyBase('usersManagement'),
    roles:createProxyBase('roles'),
    toroidalContacts:createProxy('catalogos/ToroidalContacts','catalogos/ToroidalContacts'),
    correctionContacts:createProxy('catalogos/CorrectionContacts','catalogos/CorrectionContacts'),
    items:createProxy('items','items'),
    itemTypes:createProxy('items/types','items/types'),
    itemProviders:createProxy('items/itemProviders','items/itemProviders'),
    providersByItem: itemId => createProxyBase(`items/${itemId}/providers`),
    masterCatalogs:createProxy('catalogos/entries','catalogos/entries'),
    masterGroupedCatalogs:createProxy('catalogos/GroupedEntries'),
    rates:createProxyBase('rates'),
    inPutProducts: createProxyBase('inPutProducts'),  
    outPutProducts: createProxyBase('outPutProducts'),
    areaProducts : areaId => createProxyBase(`area/${areaId}/products`)   ,
    fileRates: createProxy('', 'rates/post/file'),
};

uri.account = 'account/auth';
uri.loginTwoFactor = 'account/auth';
uri.account = 'account/auth';
uri.changepassword = 'account/changepassword';
uri.resetPassword = 'account/resetpassword';

uri.clients.asCatalog = 'clients/asCatalog';
uri.receivables.byBill = billId =>`receivables/bill/get/${billId}`;
uri.items.asCatalog = 'items/asCatalog';

uri.appointments.getByClientId = clientId =>`appointments/getbyclient/${clientId}`;
uri.sms.getByClientId = clientId =>`sms/get/${clientId}`;
uri.resources=(roleId)=>`roles/${roleId}/resources`;


uri.itemValues=(itemId)=>`items/${itemId}`;
uri.prices="items/prices";
uri.providerCatalog='providers/get';

uri.catalogEntries=(catalog)=>`catalogos/${catalog}/entries`;
uri.catalogNames='catalogos/names';
uri.catalogEntriesByNames='catalogos/entriesByNames';
uri.catalogEntriesSearch='catalogos/entries/search';

/*Filtro por tipos de articulos que deben ser llamados por las listas principales(la paginacion es requida) */
uri.itemsByType=(typeId)=>`items/bytypes/${typeId}`;
uri.lensItems='items/LentesOftalmicos';
uri.contactLensItems='items/LentesDeContacto';
uri.frameItems='items/MarcoAro';
uri.scleralItems='items/LentesEclerales';


uri.records = clientId => {
    let urls = createProxy(`records/get/${clientId}`,`records/post`,`records/${clientId}/delete`, id => `records/getbyid/${id}`);
    return urls;
};

uri.contactLenses = clientId => {
    let urls = createProxy(`contactLenses/get/${clientId}`,`contactLenses/post`,`contactLenses/${clientId}/delete`, id => `contactLenses/getbyid/${id}`);
    return urls;
};

uri.scleralsClient = clientId => {
    let urls = createProxy(`scleralsclient/get/${clientId}`,`scleralsclient/post`,`scleralsclient/${clientId}/delete`, id => `scleralsclient/getbyid/${id}`);
    return urls;
};

uri.reports = {
    bills : {
        get : 'reports/bills/get'
    }
}

export { uriGenerate };

export default uri;